export const SET_DYNAMIC_DATA = 'SET_DYNAMIC_DATA';
export const RECEIVE_DYNAMIC_DATA = 'RECEIVE_DYNAMIC_DATA';
export const FAILED_FETCHING_DATA = 'FAILED_FETCHING_DATA';
